// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:28:53

export default {
  "id": "good-sort-master-triple-match",
  "slug": "good-sort-master-triple-match",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a49d905e3ec9474eb45936d7b70eb246-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a49d905e3ec9474eb45936d7b70eb246/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Good Sort Master: Triple Match",
      "description": "A new game for those who like to put order on the shelf, in the closet, in the refrigerator. Collect identical items in groups of 3 - sort, arrange, tidy!\nConnect items three in a row, create coziness! Cleaning has never been so interesting and fun!\nA simple and relaxing game for women and men of all ages!",
      "instructions": "1. Drag items to place 3 identical items on the same shelf.\n2. Remove all items on the shelves to complete the level.\n3. Complete levels to discover more of your favorite items!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "match3",
        "relaxing",
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "优质排序大师：三消匹配",
      "description": "为喜欢整理货架、衣柜、冰箱的人设计的新游戏。收集三件相同的物品进行整理、排列、收拾！\n将三个相同的物品连成一行，打造温馨氛围！清洁从未如此有趣和快乐！\n一款简单轻松的游戏，适合所有年龄段的男女玩家！",
      "instructions": "1. 将物品拖动到同一层架上，放置3个相同的物品。\n2. 移除架上的所有物品以完成关卡。\n3. 完成关卡以发现更多您喜爱的物品！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "三消",
        "轻松",
        "排序"
      ]
    },
    "zh-TW": {
      "title": "好排序大師：三重匹配",
      "description": "為了那些喜歡整理櫥櫃、櫥子、冰箱的人設計的新遊戲。將相同的物品分組為3個，進行分類、排列、整理！將物品連成三條線，創造溫馨！清潔從未如此有趣和好玩！適合所有年齡段的男女的簡單放鬆遊戲！",
      "instructions": "1. 拖移物品將3個相同的物品放置在同一層架上。\n2. 移除架上所有物品以完成關卡。\n3. 完成關卡以發現更多您喜愛的物品！",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "匹配3",
        "放鬆",
        "排序"
      ]
    },
    "zh-HK": {
      "title": "好分類大師：三重配對",
      "description": "為喜歡將書架、衣櫃、冰箱整理得井然有序的人設計的新遊戲。以3個一組收集相同物品——分類、排列、整齊！將物品連成三條線，創造溫馨！清潔從未這麼有趣和愉快！適合各年齡段女性和男性的簡單放鬆遊戲！",
      "instructions": "1. 拖移物品將3個相同的物品放置在同一層架上。\n2. 移除架上所有物品以完成關卡。\n3. 完成關卡以發現更多你喜愛的物品！",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "Match3",
        "輕鬆",
        "排序"
      ]
    },
    "ja": {
      "title": "グッドソートマスター：トリプルマッチ",
      "description": "棚、クローゼット、冷蔵庫の中を整頓したい人に向けての新しいゲームです。同じアイテムを3つずつまとめて、並べ替え、整頓しましょう！\nアイテムを3つ連続で結びつけて、快適さを作り出しましょう！掃除はこれまでにない楽しいものになります！\nシンプルでリラックスできるゲーム、どの年代の女性や男性にもおすすめです！",
      "instructions": "1. アイテムをドラッグして同じアイテムを同じ棚に3つ並べます。\n2. 棚の全てのアイテムを取り除いてレベルをクリアします。\n3. レベルをクリアして、お気に入りのアイテムをさらに発見しましょう！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "マッチ3",
        "リラックス",
        "並べ替え"
      ]
    },
    "ko": {
      "title": "좋은 정렬 마스터: 트리플 매치",
      "description": "서랍, 캡, 냉장고를 정리하는 사람들을 위한 새로운 게임입니다. 3개씩 동일한 아이템을 모아 정렬하고 정리하세요!\n행렬로 3개의 아이템을 연결하여 편안함을 만들어보세요! 청소가 이렇게 흥미롭고 재미있지 않았던 적이 없습니다!\n여성과 남성, 모든 연령대의 사람들을 위한 간단하고 편안한 게임입니다!",
      "instructions": "1. 아이템을 드래그하여 같은 책장에 3개의 같은 아이템을 배치하세요.\n2. 책장에 있는 모든 아이템을 제거하여 레벨을 완료하세요.\n3. 레벨을 완료하여 더 많은 즐겨찾는 아이템을 발견하세요!",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "맞추기게임",
        "쉬운",
        "정리하는"
      ]
    },
    "fr": {
      "title": "Bon Maître du Tri : Correspondance Triplo",
      "description": "Un nouveau jeu pour ceux qui aiment mettre de l'ordre sur les étagères, dans les placards, au réfrigérateur. Collectez des articles identiques par groupes de 3 - classez, arrangez, rangez !\nConnectez des articles en ligne de 3 pour créer un cocon ! Nettoyer n'a jamais été si intéressant et amusant !\nUn jeu simple et apaisant pour femmes et hommes de tous âges !",
      "instructions": "1. Glisser les éléments pour placer 3 items identiques sur la même étagère.\n2. Enlever tous les éléments sur les étagères pour terminer le niveau.\n3. Compléter les niveaux pour découvrir plus de vos éléments préférés !",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "match3",
        "apaisant",
        "tri"
      ]
    }
  }
};
